import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showTab(0);
  }

  switch(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    this.showTab(index);
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.setAttribute("aria-selected", i === index);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}
